import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { create } from 'zustand';

const useConfirmDialogStore = create((set) => ({
  title: 'Confirmation',
  message: '',
  onSubmit: undefined,
  close: () => set({ onSubmit: undefined }),
  onClose: undefined,
  cancelText: '',
  confirmText: ''
}));

export const confirmDialog = (
  onSubmit,
  message = 'Do you really want to delete all the data?',
  title = 'Confirmation',
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onClose,
  isMobil = false
) => {
  useConfirmDialogStore.setState({
    message,
    onSubmit,
    title,
    cancelText,
    confirmText,
    onClose,
    isMobil
  });
};

const ConfirmDialog = () => {
  const { title, message, onSubmit, close, cancelText, confirmText, onClose, isMobil } =
    useConfirmDialogStore();

  return (
    <Dialog open={Boolean(onSubmit)} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={close} size="large">
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        {isMobil ? (
          <Box sx={{ width: '100%', maxWidth: '767px', height: '96px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2, p: 2 }}>
            <Typography
              sx={{ fontSize: '12px', fontWeight: '400', color: '#121A22', textAlign: 'left', fontFamily: 'Noto Sans' }}
              component="div"
              dangerouslySetInnerHTML={{ __html: message }}
            />
          </Box>
        ) : (
          <Typography component="div" dangerouslySetInnerHTML={{ __html: message }} />
        )}
      </DialogContent>
      <DialogActions
        sx={isMobil ? { flexDirection: 'column', gap: 2, alignItems: 'center' } : {}}
      >
        {isMobil ? (
          <>
            <Button
              color="primary"
              sx={{ width: '284px', height: '36px', borderRadius: '24px', backgroundColor: '#2F54A5', color: '#fff', '&:hover': { backgroundColor: '#244080' } }}
              onClick={() => {
                if (onSubmit) {
                  onSubmit();
                }
                close();
              }}>
              {confirmText}
            </Button>
            <Button
              color="secondary"
              sx={{ width: '288px', height: '36px', borderRadius: '24px', color: '#2F54A5' }}
              onClick={() => {
                if (onClose) {
                  onClose();
                }
                close();
              }}>
              {cancelText}
            </Button>
          </>
        ) : (
          <>
            <Button
              color="secondary"
              onClick={() => {
                if (onClose) {
                  onClose();
                }
                close();
              }}>
              {cancelText}
            </Button>
            <Button
              color="primary"
              sx={{}}
              onClick={() => {
                if (onSubmit) {
                  onSubmit();
                }
                close();
              }}>
              {confirmText}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDialog;
